<div class="dialog">
  <h1>{{ failedUploads.length }} Failed Upload<span *ngIf="failedUploads.length !== 1">s</span></h1>

  <div class="failed-uploads">
    <app-upload-item
      *ngFor="let upload of failedUploads"
      [generatePreview]="true"
      [upload]="upload"
      [gallery]="gallery"
      [preventDismiss]="true"
    ></app-upload-item>
  </div>

  <button
    appButton
    name="confirm"
    location="failed-uploads-dialog"
    color="primary"
    spacing="full"
    size="3"
    height="4"
    (click)="dismiss()"
  >
    Dismiss<span *ngIf="failedUploads.length > 1">&nbsp;All</span>
  </button>
</div>
